module.exports = __webpack_public_path__ + "static/3-17c3fddbbd2826f1c6a47cdbf6a93b9e.png";